/* eslint-disable max-len */
/* eslint-disable camelcase */
import { I18n } from 'react-redux-i18n';
import error from '../../../app/services/error';

async function validationEmails(emails) {
  const emailsWithoutSpaces = emails.replace(/(\S)\s+(\S)/g, '$1;$2');
  const correctedEmails = emailsWithoutSpaces.replace(/[:]\s*$/, '');
  const finalEmails = !correctedEmails.trim() ? '' : correctedEmails;
  const regexDefault = /^(\S+@\S+\.\S+([;:\s]*\S+@\S+\.\S+)?)*$/;
  const isValid = regexDefault.test(finalEmails);

  return isValid ? finalEmails : error('emailEkamError');
}

async function validation(form, goalOff, companyTag) {
  const {
    client_str_freight,
    client_int_payment_terms,
    client_str_location,
    client_str_deposit,
    client_str_bu,
    client_int_price_policy,
    client_str_purpose,
    client_str_buy_button_label,
    client_bol_file_email_xml,
    client_bol_file_email_csv,
    client_bol_file_email_pdf,
    client_bol_file_email_json,
    client_bol_display_client_description,
    client_bol_show_contract_product_without_price,
    client_bol_allow_sell_spot_itens_without_stock,
    client_bol_client_withdraw,
    client_bol_delivery_address_type,
    client_flo_minimum_purchase,
    client_flo_minimum_product,
    client_bol_automatic_billing,
    emailsEkam,
  } = form;
  const suppressValidations = companyTag === 'chile';

  if (!suppressValidations) {
    if (!client_str_freight) return { message: I18n.t('freightNotSelected') };
    if (!client_int_payment_terms && client_int_payment_terms !== 0) return { message: I18n.t('paymentConditionNotSelected') };
    if (!client_str_location && companyTag !== 'nortel') return { message: I18n.t('placeNotSelected') };
    if (!client_str_bu && client_str_bu !== 0) return { message: I18n.t('buNotSelected') };
    if (!client_int_price_policy && client_int_price_policy !== 0) return { message: I18n.t('policyNotSelected') };
    if (!client_str_purpose && !goalOff) return { message: I18n.t('golNotSelected') };
    if (!client_str_deposit) return { message: I18n.t('depositNotSelected') };
    if (!client_str_buy_button_label) return { message: I18n.t('buttonNotInserted') };
  }
  if (client_bol_display_client_description === null
    || client_bol_display_client_description === ''
    || client_bol_display_client_description === undefined) { return { message: I18n.t('showDescription') }; }
  if (client_bol_show_contract_product_without_price === null
    || client_bol_show_contract_product_without_price === ''
    || client_bol_show_contract_product_without_price === undefined) {
    return { message: I18n.t('showContractProductWithoutPriceError') };
  }
  if (client_bol_allow_sell_spot_itens_without_stock === null
    || client_bol_allow_sell_spot_itens_without_stock === ''
    || client_bol_allow_sell_spot_itens_without_stock === undefined) {
    return { message: I18n.t('allowSellSpotItensWithoutStockError') };
  }

  if (client_bol_automatic_billing === null
    || client_bol_automatic_billing === ''
    || client_bol_automatic_billing === undefined) {
    return { message: I18n.t('autoBillingError') };
  }

  let validatedEmails;
  if (emailsEkam) {
    try {
      validatedEmails = await validationEmails(emailsEkam);
    } catch (e) {
      return { message: I18n.t('emailEkamError') };
    }
  }

  return {
    client_str_freight,
    client_int_payment_terms,
    client_str_location,
    client_str_deposit,
    client_str_bu,
    client_int_price_policy,
    client_str_purpose,
    client_str_buy_button_label,
    client_bol_file_email_xml,
    client_bol_file_email_csv,
    client_bol_file_email_pdf,
    client_bol_file_email_json,
    client_bol_display_client_description,
    client_bol_show_contract_product_without_price,
    client_bol_client_withdraw,
    client_bol_delivery_address_type,
    client_bol_allow_sell_spot_itens_without_stock,
    client_flo_minimum_purchase,
    client_flo_minimum_product,
    client_bol_automatic_billing,
    emailsEkam: validatedEmails,
  };
}

export default {
  validation,
};
